import { useState } from "react";
import { videos } from "@/mocks/videos";
import { categories } from "@/mocks/categories";
import VideoCard from "@/components/base/VideoCard";

export default function FeaturedVideos() {
  const [activeTab, setActiveTab] = useState("all");
  const featuredCats = categories.filter((c) => c.featured);

  const filteredVideos =
    activeTab === "all"
      ? videos.filter((v) => v.isHot).slice(0, 8)
      : videos.filter((v) => v.category === activeTab).slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精选热门视频
          </h2>
          <p className="text-sm text-foreground-600">
            精选各平台最受欢迎的影视内容，热门好剧一网打尽
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 mb-8 flex-wrap">
          <button
            onClick={() => setActiveTab("all")}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeTab === "all"
                ? "bg-primary-500 text-background-50"
                : "bg-background-50 text-foreground-600 border border-background-200/70 hover:border-primary-300"
            }`}
          >
            全部热门
          </button>
          {featuredCats.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveTab(cat.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeTab === cat.slug
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-600 border border-background-200/70 hover:border-primary-300"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {filteredVideos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}